import { autoWebViewJs } from "@droid/android";
import { useTranslation } from "@fanfanlo";
import { Box, Button } from "@mui/material";
import { PropsWithChildren } from "react";

export interface IOpenBrowserButtonParams{
    url:string
    name?:string
}
export function OpenBrowserButton({url, name}:IOpenBrowserButtonParams){
    const {t} = useTranslation('homepage/components/browser/content')

    const onClick = ()=>{
        const script = `
        com.fanfanlo.lib.browser.BrowserLauncher.openTutorialUrl("${url}")
        `
        autoWebViewJs.callScript(script)
    }

    return(<>
        <Button onClick={onClick} data-testid="OpenBrowserButton__openButton__01JG2B0080" data-test-comment="打开浏览器按钮，点击后在系统浏览器中打开指定URL">
            {name || t("OpenBrowserButton.buttonName")}
        </Button>
    </>)
}

export function OpenBrowserButtonBox(params:IOpenBrowserButtonParams){
    return(
        <>
            <Box>
                <OpenBrowserButton url={params.url} name={params.name}/>
            </Box>
        </>
    )
}

